import * as React from "react";
import { useTranslation } from "react-i18next";
import { ICanvasProps } from "@/components/ui/Canvas/Models";
import { HeaderTitleWrapper } from "../Styles";
import {
  CategoryIconActive,
  LocationIcon,
  LocationIconActive,
} from "@/components/ui/Icons/IconsCustom";
import Canvas from "@/components/ui/Canvas";
import { useSelector } from "react-redux";
import {
  IDefaultRequest,
  ISettingStore,
} from "@/redux/slices/settings/SettingModel";
import { RootState } from "@/redux";
import { LocationContentBaseWrapper } from "./Styles";
import TreeSelect from "@/components/ui/TreeSelect";
import { IOrganizationStore } from "@/redux/slices/organizations/OrganizationModel";
import { ROOT } from "@/services/resource-service/entity/Enums";
import { Button, MessageBarTitle } from "@fluentui/react-components";
import { useDispatch } from "react-redux";
import { IFetchRequest } from "@/services";
import { updateDefault } from "@/redux/slices/settings/SettingSlice";
import { IMessageItem } from "../Models";

export class CategoriesSettingsProp {
  addMessage?: (payload: IMessageItem) => void;
}

export const CategoriesSetting: React.FC<any> = (
  props: CategoriesSettingsProp
) => {
  const { t } = useTranslation();

  const orgStore: IOrganizationStore = useSelector(
    (state: RootState) => state.orgInfo
  ) as IOrganizationStore;

  const settingStore: ISettingStore = useSelector(
    (state: RootState) => state.settingInfo
  ) as ISettingStore;

  const theme: string = useSelector(
    (state: RootState) => state.settingInfo?.theme
  ) as string;

  const [isOpen, setIsOpen] = React.useState<boolean>(false);

  const args: ICanvasProps = {
    headerTitle: (
      <HeaderTitleWrapper className="HeaderTitleWrapper">
        <CategoryIconActive theme={settingStore.theme} />
        <span>{t("Default Categories")}</span>
      </HeaderTitleWrapper>
    ),
    isStickHeader: false,
    isOpen: isOpen,
    onOpen: (isOpen: boolean) => {
      setIsOpen(isOpen);
    },
  };

  const [cateIds, setCateIds] = React.useState<string[]>([]);
  const [initialCateIds, setInitialCateIds] = React.useState<string[]>([]);

  React.useEffect(() => {
    if (settingStore) {
      const ids = settingStore?.defaultCategories.split(",");
      setCateIds(ids.filter(item => !!item));
      setInitialCateIds(ids.filter(item => !!item));
    }
  }, [settingStore]);

  const onChange = (arr: string[]): void => {
    setCateIds(arr.filter(item => !!item));
  };
  const onApply = (): void => {};

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const onClear = (_arr?: string[], key?: string): void => {
    setCateIds([]);
  };

  const isCategoriesChanged = React.useMemo(() => {
    return JSON.stringify(cateIds.sort()) !== JSON.stringify(initialCateIds.sort());
  }, [cateIds, initialCateIds]);

  const dispatch = useDispatch();

  const handleSaveSettings = () => {
    try {
      const OrganizationInfo: IFetchRequest = {
        tenantId: orgStore.orgInfo?.tenantId || "",
        orgId: orgStore.orgInfo?.guid || "",
      };
      const payload: IDefaultRequest = {
        OrganizationInfo: OrganizationInfo,
        type: "CATE",
        Ids: (cateIds && cateIds.join(",")) || "",
      };
      dispatch(updateDefault(payload));

      const msg: IMessageItem = {
        id: new Date().getTime().toString(),
        type: "success",
        content: (
          <>
            <MessageBarTitle>{t("Save default categories successfully")}!</MessageBarTitle>
          </>
        ),
        autoClose: 3000,
      };
      props?.addMessage && props.addMessage(msg);
    } catch (error) {
      console.error("Đã xảy ra lỗi khi lưu cài đặt:", error);
      const errorMsg: IMessageItem = {
        id: new Date().getTime().toString(),
        type: "error",
        content: (
          <>
            <MessageBarTitle>Something error!</MessageBarTitle>
          </>
        ),
        autoClose: 5000,
      };
      props?.addMessage && props.addMessage(errorMsg);
    }
  };

  return (
    <LocationContentBaseWrapper className="rf-settings-tree-wrapper">
      <Canvas {...args} theme={settingStore.theme || undefined}>
        <div className="rf-settings-content">
          <div style={{ position: "relative" }}>
            <TreeSelect
              items={orgStore?.categoryTrees || []}
              values={cateIds}
              size="small"
              onChange={onChange}
              iconLeft={<LocationIcon theme={theme} />}
              iconLeftActive={<LocationIconActive theme={theme} />}
              displayLabelValue={t("Locations")}
              lblSelect={t("Locations")}
              style={{ minWidth: "100%" }}
              onApply={onApply}
              onClear={(arr?: string[]) => onClear(arr, "location")}
              expanded={[orgStore.orgInfo?.tenantId || ROOT]}
              theme={theme}
              rcName="filter_location"
              isDisplayOnlyTree={true}
            />
            <div className="btn-group">
              <Button onClick={() => onClear()}>{t("Clear")}</Button>
              <div
                className={`rf-settings-button-apply ${isCategoriesChanged ? 'active' : ''}`}
                onClick={() => {
                  isCategoriesChanged && handleSaveSettings();
                }}
                title={t("Apply")}
                style={{
                  backgroundColor: isCategoriesChanged ? '#0078d4' : '#b9b9b9',
                  color: isCategoriesChanged ? 'white' : '#f1f0ef',
                  cursor: isCategoriesChanged ? 'pointer' : 'default',
                }}
              >
                {t("Apply")}
              </div>
            </div>
          </div>
        </div>
      </Canvas>
    </LocationContentBaseWrapper>
  );
};
